import React from "react";
import type { TextColor } from "@/app/types/ui";

interface ParagraphProps {
  children: React.ReactNode;
  color?: TextColor; // Pass the Tailwind text-color class you need
}

export const Paragraph = ({
  children,
  color = "text-black",
}: ParagraphProps) => {
  return <p className={`${color} text-base`}>{children}</p>;
};
